
import React from 'react';
import { motion } from 'framer-motion';

function MarketingStrategies() {
    const strategies = [
        {
            title: 'Search Engine Optimization (SEO)',
            description: 'Improve your website ranking on search engines to increase organic traffic and visibility.',
            Image: 'images/seo.png'
        },
        {
            title: 'Pay-Per-Click Advertising (PPC)',
            description: 'Drive targeted traffic to your website through paid ads on platforms like Google Ads and Meta Ads.',
            Image: 'images/ppc.png',
        },
        {
            title: 'Social Media Marketing',
            description: 'Engage with your audience and build brand awareness on social media platforms like Facebook, Instagram, and LinkedIn.',
            Image: 'images/smm.png',
        },
        {
            title: 'Content Marketing',
            description: 'Create and distribute valuable content to attract and retain a clearly defined audience.',
            Image: 'images/content-marketing.png',
        },
        {
            title: 'Email Marketing',
            description: 'Nurture leads and build customer relationships through targeted email campaigns.',
            Image: 'images/email-marketing.png',
        },
        {
            title: 'Web Design & Development',
            description: 'We build high-performance, conversion-led websites that blend cutting-edge aesthetics with seamless functionality to turn your digital traffic into loyal customers.',
            Image: 'images/am.png',
        },
    ];

    // Animation Variants
    const containerVariants = {
        hidden: { opacity: 0 },
        visible: {
            opacity: 1,
            transition: { staggerChildren: 0.2 }
        }
    };

    const cardVariants = {
        hidden: { y: 50, opacity: 0 },
        visible: {
            y: 0,
            opacity: 1,
            transition: { type: 'spring', stiffness: 100 }
        }
    };

    return (
        <div className="max-w-7xl mx-auto px-6 py-16 overflow-hidden">
            {/* Header Section */}
            <motion.div
                initial={{ x: -100, opacity: 0 }}
                whileInView={{ x: 0, opacity: 1 }}
                viewport={{ once: true }}
                className="space-y-6"
            >
                <h1 className="text-4xl md:text-6xl font-bold text-primary leading-tight">
                    Want to boost your <span className="italic underline decoration-secondary">business growth?</span>
                </h1>
                <h1 className="text-5xl md:text-7xl font-extrabold text-primary">
                    The <b className='text-secondary animate-pulse'>SOLUTION</b> is here...
                </h1>
                <p className='text-gray-600 text-lg md:text-2xl mt-8 max-w-4xl leading-relaxed'>
                    We help businesses grow online through powerful digital marketing strategies.
                    From <span className="font-semibold text-primary">paid ads</span> to brand building, we focus on real results.
                    Every brand is unique, so we create customized plans that match your goals.
                </p>
            </motion.div>

            {/* Strategies Grid */}
            <motion.div
                variants={containerVariants}
                initial="hidden"
                whileInView="visible"
                viewport={{ once: true }}
                className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12 mt-24"
            >
                {strategies.map((item, index) => (
                    <motion.div
                        key={index}
                        variants={cardVariants}
                        whileHover={{
                            y: -10,
                            boxShadow: "0px 20px 40px rgba(0,0,0,0.1)"
                        }}
                        className='group relative border-2 border-primary/20 p-8 flex flex-col items-center space-y-6 rounded-2xl bg-white/50 backdrop-blur-sm transition-all duration-300'
                    >
                        <h1 className='w-full text-center absolute -top-6 left-0 right-0 mx-auto max-w-[80%] bg-primary text-white text-lg md:text-xl font-bold rounded-full py-3 px-4 shadow-lg group-hover:bg-secondary transition-colors duration-500'>
                            {item.title}
                        </h1>

                        <div className="pt-6">
                            <motion.img
                                whileHover={{ rotate: 360 }}
                                transition={{ duration: 0.7 }}
                                src={item.Image}
                                alt={item.title}
                                className='h-28 w-28 object-contain drop-shadow-md'
                            />
                        </div>

                        <p className='text-gray-600 text-center text-lg md:text-xl leading-snug group-hover:text-primary transition-colors'>
                            {item.description}
                        </p>
                        <div className="w-0 h-1 bg-secondary group-hover:w-full transition-all duration-500 rounded-full"></div>
                    </motion.div>
                ))}
            </motion.div>
        </div>
    );
}

export default MarketingStrategies;